import request from '@/utils/request.js'
const gatewayPrefix = "/studyService/api"



/**
 * 课程列表页-学习计划的弹窗相关
 * @param params
 * @returns {AxiosPromise}
 */
export function alert(params) {
    return request({
        url: gatewayPrefix + '/app/userStudyPlan/alert',
        method: 'post',
        data: params
    })
}




/**
 * 学习计划-开关提醒
 * @param params
 * @returns {AxiosPromise}
 */
export function changeRemindSwitch(params) {
    return request({
        url: gatewayPrefix + '/app/userStudyPlan/changeRemindSwitch',
        method: 'post',
        data: params,
        closeLoading: true
    })
}




/**
 * 学习计划-启用计划
 * @param params
 * @returns {AxiosPromise}
 */
export function enablePlan(params) {
    return request({
        url: gatewayPrefix + '/app/userStudyPlan/enablePlan',
        method: 'post',
        data: params
    })
}




/**
 * 学习计划-与用户有关的信息-定时-开关之类的
 * @param params
 * @returns {AxiosPromise}
 */
export function getRemindInfo(params) {
    return request({
        url: gatewayPrefix + '/app/userStudyPlan/getRemindInfo',
        method: 'post',
        data: params,
        closeLoading: true
    })
}




/**
 * 我的学习计划列表
 * @param params
 * @returns {AxiosPromise}
 */
export function list(params) {
    return request({
        url: gatewayPrefix + '/app/userStudyPlan/list',
        method: 'post',
        data: params
    })
}

/**
 * 我的学习计划列表-所有的
 * @param params
 * @returns {AxiosPromise}
 */
export function listAllPlan(params) {
    return request({
        url: gatewayPrefix + '/app/userStudyPlan/listAllPlan',
        method: 'post',
        data: params
    })
}


/**
 * 学习计划-首页展示
 * @param params
 * @returns {AxiosPromise}
 */
export function changePortalShowSwitch(params) {
    return request({
        url: gatewayPrefix + '/app/userStudyPlan/changePortalShowSwitch',
        method: 'post',
        data: params,
        closeLoading: true
    })
}
/**
 * 学习计划-每日章节详情
 * @param params
 * @returns {AxiosPromise}
 */
export function listDayPlan(params) {
    return request({
        url: gatewayPrefix + '/app/userStudyPlan/listDayPlan',
        method: 'post',
        data: params,
        closeLoading: true
    })
}




/**
 * 学习计划-学习计划列表
 * @param params
 * @returns {AxiosPromise}
 */
export function listPlanTask(params) {
    return request({
        url: gatewayPrefix + '/app/userStudyPlan/listPlanTask',
        method: 'post',
        data: params,
        closeLoading: true
    })
}




/**
 * 学习计划-提醒-设置提醒时间
 * @param params
 * @returns {AxiosPromise}
 */
export function setRemindRule(params) {
    return request({
        url: gatewayPrefix + '/app/userStudyPlan/setRemindRule',
        method: 'post',
        data: params
    })
}




//全部方法
//alert、changeRemindSwitch、enablePlan、getRemindInfo、list、listDayPlan、listPlanTask、setRemindRule